import withConfirm from 'with/withConfirm';
import Checkbox from './Checkbox';

export default withConfirm(Checkbox);
